import { useCallback, useMemo } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { UserFriendlyError } from '../../../../model/Error'
import { trustedSourceKeys } from './trustedSource.keys'
import { getTrustedSources } from '../../../../data/admin/trustedSources/getTrustedSources'

export const useGetTrustedSources = () => {
  const queryKey = useMemo(() => trustedSourceKeys.all, [])

  const queryReturn = useQuery({
    queryKey,
    queryFn: async () => {
      const { data, ok } = await getTrustedSources()
      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          `Impossible de récupérer la liste des pièces justificatives`,
          `Une erreur technique s'est produite`,
        )
      }

      const trustedSources = data || []
      return {
        defaultSources: trustedSources.filter((source) => source?.isDefault),
        customSources: trustedSources.filter((source) => !source?.isDefault),
      }
    },
  })

  const queryClient = useQueryClient()

  const cancelPendingQuery = useCallback(() => {
    queryClient.cancelQueries({ queryKey })
  }, [queryClient, queryKey])

  return { query: queryReturn, cancelPendingQuery }
}
